"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useToggle = _interopRequireDefault(require("react-use/lib/useToggle"));
var _Tooltip = require("b2b-components/core/components/Tooltip/Tooltip");
var _TooltipContainer = require("b2b-components/core/components/Tooltip/TooltipContainer.types");
var _useOutsideMouseEvent = require("b2b-components/hooks/useOutsideMouseEvent");
var _server = require("b2b-components/utils/server");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TooltipContainer = props => {
  const {
    isHoverable = true,
    rootElementId,
    shouldHideOnContentMouseOver,
    children,
    triggerClassName,
    contentClassName,
    ...originalProps
  } = props;
  const {
    hasTriggerWidth
  } = originalProps;
  const [isPending, startTransition] = (0, _react.useTransition)();
  const [isVisible, toggleHandler] = (0, _useToggle.default)(false);
  const [hasPositionCalculated, setHasPositionCalculated] = (0, _react.useState)(false);
  const scrollY = !_server.isServer ? window.scrollY : 0;
  const body = !_server.isServer ? document.body : undefined;
  const clientHeight = body?.clientHeight || 0;
  const clientWidth = body?.clientWidth || 0;
  const wrapperRef = (0, _react.useRef)(null);
  const contentRef = (0, _react.useRef)(null);
  const triggerLeft = wrapperRef.current?.getBoundingClientRect().left || 0;
  const triggerTop = wrapperRef.current?.getBoundingClientRect().top || 0;
  const overrideContentClassName = (0, _classnames.default)(contentClassName, {
    'cds-Tooltip-Content--ContentHover': shouldHideOnContentMouseOver
  });
  const overrideTriggerClassName = (0, _classnames.default)(triggerClassName, {
    'cds-Tooltip-Trigger--HideOnMouseOver': shouldHideOnContentMouseOver
  });
  (0, _useOutsideMouseEvent.useOutsideMouseEvent)('click', [wrapperRef], () => {
    if (isVisible) {
      toggleHandler(false);
      setHasPositionCalculated(false);
    }
  }, {
    rootElementId
  });
  (0, _useOutsideMouseEvent.useOutsideMouseEvent)('mouseover', [contentRef, wrapperRef], () => {
    if (isVisible && isHoverable) {
      toggleHandler(false);
      setHasPositionCalculated(false);
    }
  }, {
    options: {
      capture: true
    }
  });
  const handleMouseOver = () => {
    if (isVisible && isHoverable && !isPending) {
      shouldHideOnContentMouseOver && toggleHandler(false);
    }
  };
  const handleMouseEnter = () => {
    if (isHoverable) {
      startTransition(() => {
        toggleHandler(true);
      });
    }
  };
  const handleMouseLeave = () => {
    if (isHoverable) {
      toggleHandler(false);
    }
  };
  const handleClick = e => {
    e.stopPropagation();
    toggleHandler();
  };
  const [positionConfig, setPositionConfig] = (0, _react.useState)({
    left: triggerLeft,
    top: triggerTop,
    orientation: _TooltipContainer.TOOLTIP_POSITION.bottom,
    width: 0
  });
  (0, _react.useEffect)(() => {
    if (isVisible && contentRef.current && wrapperRef.current) {
      const triangleSpacing = 5;
      //measure sizes and distances
      const tooltipHeight = contentRef.current.offsetHeight;
      const tooltipWidth = contentRef.current.offsetWidth;
      const triggerHeight = wrapperRef.current.offsetHeight;
      const triggerWidth = wrapperRef.current.offsetWidth;
      const triggerLeft = wrapperRef.current.getBoundingClientRect().left || 0;
      const triggerTop = wrapperRef.current.getBoundingClientRect().top || 0;
      const triggerRight = clientWidth - (triggerLeft + triggerWidth);
      const triggerBottom = clientHeight - scrollY - (triggerTop + triggerHeight);
      let left = contentRef.current.getBoundingClientRect().left || 0;
      let top = contentRef.current.getBoundingClientRect().top || 0;
      let orientation = _TooltipContainer.TOOLTIP_POSITION.bottom;
      let width = 0;
      if (hasTriggerWidth) {
        left = triggerLeft;
        top = triggerTop + scrollY + triggerHeight + triangleSpacing;
        width = triggerWidth;
      } else if (
      //it's okay to stay at the bottom
      triggerLeft - tooltipWidth / 2 >= 0 && triggerRight - tooltipWidth / 2 >= 0 || triggerWidth >= tooltipWidth || tooltipWidth >= triggerLeft) {
        left = triggerLeft - tooltipWidth / 2 + triggerWidth / 2;
        top = triggerTop + scrollY + triggerHeight + triangleSpacing;
      } else if (triggerRight - tooltipWidth / 2 < 0) {
        //needs to be moved to the left
        left = triggerLeft - tooltipWidth - triangleSpacing;
        top = triggerTop + scrollY + triggerHeight / 2 - tooltipHeight / 2;
        orientation = _TooltipContainer.TOOLTIP_POSITION.left;
      } else if (triggerLeft - tooltipWidth / 2 < 0) {
        //needs to be moved to the right
        left = triggerLeft + triggerWidth + triangleSpacing;
        top = triggerTop + scrollY + triggerHeight / 2 - tooltipHeight / 2;
        orientation = _TooltipContainer.TOOLTIP_POSITION.right;
      }
      if (triggerBottom - tooltipHeight < 0) {
        //needs to be moved to the top
        top = triggerTop + scrollY - tooltipHeight - triangleSpacing;
        orientation = _TooltipContainer.TOOLTIP_POSITION.top;
      }
      setHasPositionCalculated(true);
      setPositionConfig({
        left,
        top,
        orientation,
        width
      });
    }
  }, [isVisible, clientHeight, clientWidth, hasTriggerWidth, scrollY]);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, (0, _extends2.default)({}, originalProps, {
    isVisible: isVisible,
    hasPositionCalculated: hasPositionCalculated,
    positionConfig: positionConfig,
    wrapperRef: wrapperRef,
    contentRef: contentRef,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    handleMouseOver: handleMouseOver,
    contentClassName: overrideContentClassName,
    triggerClassName: overrideTriggerClassName
  }), children);
};
exports.TooltipContainer = TooltipContainer;
//# sourceMappingURL=TooltipContainer.js.map